// extracted by mini-css-extract-plugin
module.exports = {"chatContainer":"ChatWindow_chatContainer__13iaJ","show":"ChatWindow_show__cUv8b"};